import React from 'react';
import ReactDOM from 'react-dom';
import {
   Content
} from '@beisen/chaos-ui';
import * as urlHelper from '../util/url';
import * as pageError from '../util/pageError';
import ListLoad from '../ListLoad/ListLoad';
import DataTable from '../DataTable/DataTable';
import { getExtensionCmp, getExtensionCmpByViewPath  } from '../util/extension';
import { isNotEmpty } from '../util/check';
import PopViewButton from '../PopIndexView/PopViewButton';
class IndexContent extends React.Component {
    constructor(props) {
        super(props);
		this.selectAll = this.selectAll.bind(this);
		this.selectItem = this.selectItem.bind(this);
		this.state = {
			selectIds: '',
            globleChecked: false,
            selectData: []
		};
    }

    existNavView() {
        return isNotEmpty(this.props.indexData,['NavView','cmp_data']);
    }

    getContentScrollTop() {
        return this.refs.indexContainer ? ReactDOM.findDOMNode(this.refs.indexContainer).scrollTop : 0;
    }

    updateSearchCondition(biz_data) {
        const { indexData,actions } = this.props;
        if(indexData.SearchForm) {
            actions.common_set_data(indexData.SearchForm.cmp_id,null,biz_data,'biz_data');
            //快速筛选项 取值从biz_data 高级筛选 从tempSearchData
            actions.common_set_data(indexData.SearchForm.cmp_id,null,biz_data,'tempSearchData');
        }
    }

    remerberBeforeJump() {
        if(this.existNavView()) {
            const url = urlHelper.removeParam('_k',location.href);
            localStorage.setItem(BSGlobal.loginUserInfo.Id + '_' + url + '-viewName',this.props.indexData.NavView.cmp_data.currentViewName);
        }
    }

    clearMemoryAfterMount() {
        const url = urlHelper.removeParam('_k',location.href);
        localStorage.removeItem(BSGlobal.loginUserInfo.Id + '_' + url + '-viewName');
    }

    handleToTop() {
        this.props.displayTopAndBottom();
        this.refs.table && this.refs.table.handleToTop && this.refs.table.handleToTop();
    }

    changeHolderHeight(height) {
        this.refs.holder && (this.refs.holder.style.height = height);
    }

    clearSelectData(source) {
        if(source == 'fromSearch' || (source == 'fromSort' && !this.state.globleChecked)) {
            this.setState({
                selectIds: '',
                selectData: [],
                globleChecked: false
            });
        }
    }
    // 触发条件是搜索时 清空选中数据 触发条件是排序时 如果已点击了全选则不清空 如果只单独点击了某几条则清空选中数据
    reload(data,source) {
        if(this.refs.table) {
            this.handleToTop();
            this.props.setSortData && this.props.setSortData(data);
            source && this.clearSelectData(source);
            this.refs.table.reloadTable(data);
        }
    }

    transtoKeyValue(obj) {
        let finalObj = {};
        for (let key in obj) {
            if (obj[key] && obj[key].name == key) {
                finalObj[key] = obj[key].value;
            }
        }
        return finalObj;
    }

    selectAll(e) {
		e.preventDefault();
		const { biz_data } = this.props.indexData.TableList;
        let { globleChecked } = this.state;
		if (globleChecked) {
			this.setState({
                selectIds: '',
                selectData: [],
                globleChecked: false
			});
		} else {
			if (biz_data && biz_data.length > 0) {
                const ids = biz_data.map(rowItem => {
                    return rowItem['_id'] && rowItem['_id'].value;
                });
				this.setState({
					selectIds: ids.join(','),
                    globleChecked: !globleChecked
				});
			}
		}
	}

    selectItem(e,currentItem) {
        const { TableList = {} } = this.props.indexData;
        if(!TableList.cmp_data.hasCheckColumn) return;
        e.preventDefault();
        const { single } = this.props.popButtonData.cmp_data;
        let { selectData,globleChecked } = this.state;
        if(single) {
            const currentItemObj = this.transtoKeyValue(currentItem);
            this.setState({
                selectIds: currentItemObj['_id'],
                selectData: [currentItemObj],
                globleChecked: false
            });
            return;
        }
        
        if(globleChecked) {
            this.setState({
                selectIds: '',
                selectData: [],
                globleChecked: false
            });
            return;
        }
        let selectedData = selectData.concat();
		if (!currentItem.checked) {
			let currentItemObj = {};
			for (let key in currentItem) {
				if (currentItem[key] && currentItem[key].name == key) {
					currentItemObj[key] = currentItem[key].value;
				}
			}
			selectedData.push(currentItemObj);
		} else {
			selectedData = selectData.filter(Item => {
				return currentItem['_id'].value != Item['_id'];
			});
        }
        
        const ids = selectedData.map(rowItem => {
            return rowItem['_id'];
        });

		this.setState({
            selectIds: ids.join(','),
            selectData: selectedData,
            globleChecked: false
		});
    }

    getList() {
        const { indexData,
                actions,
                queryUrl,
                tableAjaxParam,
                isIndexPop,
                onRowTouchTap,
                hideTopAndBottom,
                displayTopAndBottom,
                displayToTop,
                hideToTop,
                hasSticky,
                hasButton,
                isFetching,
                searchData,
                indexContext,
                cmpContext,
                popParams,
                popButtonData,
                translation,
                getFooterHeight
             } = this.props;
        const DestCmp = getExtensionCmp(indexData.TableList) || DataTable;
        return (
                <Content  ref="indexContainer" cls='indexpage_content'>
                    {hasSticky ? <div className="holder" ref="holder" /> : null}
                    <DestCmp ref="table" {...indexData.TableList}
                        isIndexPop={isIndexPop}
                        popParams={popParams}
                        updateSearchCondition={this.updateSearchCondition.bind(this)}
                        actions={actions}
                        queryUrl={queryUrl}
                        searchData={searchData}
                        tableAjaxParam={tableAjaxParam}
                        indexContext={indexContext}
                        cmpContext={cmpContext}
                        onRowTouchTap={onRowTouchTap}
                        isFetching={isFetching}
                        allowPTR={true}
                        rememberBeforeJump={this.remerberBeforeJump.bind(this)}
                        clearMemoryAfterMount={this.clearMemoryAfterMount.bind(this)}
                        hideTopAndBottom={hideTopAndBottom}
                        displayTopAndBottom={displayTopAndBottom}
                        hasBottomButton={hasButton}
                        isAndroid={window.env.platform.android}
                        displayToTop={displayToTop}
                        hideToTop={hideToTop}
                        isNoShowRowButton={isIndexPop}
                        showChecked={isIndexPop}
                        onTableItemClick={isIndexPop ? this.selectItem : null}
                        selectIds={this.state.selectIds}
                        globleChecked={this.state.globleChecked}
                        disableRemberPosition={isIndexPop}
                        tableType={isIndexPop ? 'popViewTable' : ''}
                        getFooterHeight={getFooterHeight}
                    />
                    {isIndexPop ? <PopViewButton translation={translation}
                                                    popButtonData={popButtonData}
                                                    searchData={searchData}
                                                    actions={actions}
                                                    pageData={indexData.TableList.cmp_data.paging}
                                                    hasGlobleCheck={indexData.TableList.cmp_data.isEnableGlobleCheck && !popButtonData.cmp_data.single}
                                                    globleChecked={this.state.globleChecked}
                                                    selectAll={this.selectAll}
                                                    selectIds={this.state.selectIds}
                                                    selectData={this.state.selectData} /> : null}
                </Content>
            );
    }

    renderLoadingOrError() {
        const { errors = {},indexData } = this.props;
        if(errors && errors.code) {
            return pageError.errorPage(this.props);
        }

        if(indexData.status == 'loading') {
            return (
                    <Content> <ListLoad /> </Content>
            );
        }
        return null;
    }

    render() {
        const { indexPageProps,currentViewIsCustomComponent,customComponent } = this.props;
        const noContentPage = this.renderLoadingOrError();
        if(noContentPage) {
            return noContentPage;
        }

        if(currentViewIsCustomComponent) {
            const ExtensionCmp = getExtensionCmpByViewPath(customComponent);
            return (<div className='ui-page-content indexpage_content' ref="indexContent">
                    <ExtensionCmp {...indexPageProps} />
                  </div>);
        }


        return this.getList();
    }
       
}

IndexContent.defaultProps = {
    indexData: {},
    popButtonData: {
        cmp_data: {

        }
    }
};
export default IndexContent;



// WEBPACK FOOTER //
// ./src/components/Pages/IndexContent.js